import { axios } from "@app/app";
import { bookingQueries, bookingTypes } from "@app/booking";
import { paymentQueries, PaymentTypes } from "@app/payment";
import { TPaymentIntentModel } from "@app/payment/types";

import { ICheckoutSessionState, IPCIBookingAccessToken } from "./types";

export const upsertCheckoutSession = async (
    propertyId: string,
    searchQuery: string,
    state?: ICheckoutSessionState | undefined
): Promise<ICheckoutSessionState> => {
    const response = await axios.post<ICheckoutSessionState>(`/properties/${propertyId}/checkout/checkout-session?${searchQuery}`, state);

    return response.data;
};

export const getPCIBookingAccessToken = async (): Promise<IPCIBookingAccessToken> => {
    const response = await axios.get<IPCIBookingAccessToken>("/pci-booking/access-token");

    return response.data;
};

export interface IGetCheckoutBookingValidatableDependencyDataResult {
    reservedBooking: bookingTypes.IReservedBooking;
    paymentIntentModel?: TPaymentIntentModel;
}

export interface IGetCheckoutBookingValidatableDependencyDataProps {
    propertyId: string;
    bookingId: string;
}

export const getCheckoutBookingValidatableDependencyData = async ({
    propertyId,
    bookingId,
}: IGetCheckoutBookingValidatableDependencyDataProps): Promise<IGetCheckoutBookingValidatableDependencyDataResult> => {
    const reservedBooking = await bookingQueries.getReservedBooking(propertyId, bookingId);

    const paymentType = reservedBooking?.payment_type;
    const outDatedPaymentIntentModel =
        reservedBooking?.payment_type === PaymentTypes.Direct ? reservedBooking?.payment_intent : reservedBooking?.payment_setup_intent;
    const paymentIntentModelId = outDatedPaymentIntentModel?.id;
    let paymentIntentModel: TPaymentIntentModel | undefined;

    if (paymentType && paymentIntentModelId) {
        paymentIntentModel = await paymentQueries.getPaymentIntentModel(paymentType, paymentIntentModelId, { doSync: true });
    }

    return {
        reservedBooking,
        paymentIntentModel,
    };
};
